import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import Cookies from "universal-cookie";
import { array, func, object, string } from "prop-types";

import StaticHeader from "./StaticHeader";
import { setBookmark, setJwtToken, setMember, setMobileFilter } from "../../../helper/actions";

import "./uniformHeader.m.css";
import VerticalMenubar from "../VerticalMenubar";
import { useDeviceWidth } from "../../../utils/react-utils";
import PopupOverlay from "../../../molecules/PopupOverlay";
import { getJwt, getUser } from "../../../helper/api";
import { getCurrentSite } from "../../../utils/utils";

const { BroadcastChannel } = require("broadcast-channel");

const UniformHeader = ({
  domainMenuItemsObj,
  publisherAttributes,
  navigateToPage,
  member,
  setMember,
  setJwtToken,
  setBookmark,
  setMobileFilter,
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [dot, setDot] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [hamburgerMenu, setHamburgerMenu] = useState({});
  const [verifySuccess, setVerifySuccess] = useState(false);
  const [showPopUp, setShowPopup] = useState(true);
  const [message, setMessage] = useState("");
  const [location, setLocation] = useState(null);
  const [originalLocation, setoriginalLocation] = useState(null);
  const [isVerticalMenubar, setVerticalMenuBar] = useState(false);

  useEffect(() => {
    const channel = new BroadcastChannel("logout-channel");
    channel.onmessage = (msg) => {
      setMember(null);
      setJwtToken(null);
      setBookmark(null);
    };
  });

  useEffect(() => {
    isVerticalMenubar
      ? (global.document.body.style.overflow = "hidden")
      : (global.document.body.style.cssText = "overflow-x: hidden, overflow-y: auto");
  }, [isVerticalMenubar]);

  useEffect(() => {
    if (domainMenuItemsObj.length > 0) {
      const hamItems = domainMenuItemsObj.find((item) => item.title === "hamburger");
      setHamburgerMenu(get(hamItems, ["children"], []));
    }
  }, [domainMenuItemsObj]);

  const cookies = new Cookies();

  useDeviceWidth(setIsDesktop);

  const getNotifications = () => {
    fetch(`/feapi/push-engage-notifications?limit=4&offset=0`)
      .then((res) => res.json())
      .then((resp) => {
        setNotifications(resp.notifications);
        if (cookies.get("notifications") && resp.notifications.length > 0) {
          resp.notifications[0].notification_id !== cookies.get("notifications") ? setDot(true) : setDot(false);
        } else {
          setNotifications(resp.notifications);
          resp.notifications.length > 0 && setDot(true);
        }
      });
  };

  const changePopupView = () => {
    const isHashPresent = global.location.href.substr(0, global.location.href.indexOf("#"));
    const finalRedirectUrl = new URL(isHashPresent);
    navigateToPage(finalRedirectUrl.pathname || "/");
    setShowPopup(false);
  };

  useEffect(() => {
    if (global.location && global.location.hash === "#email-verification") {
      setVerifySuccess(true);
    }

    if (global.location) {
      if (global.location.hash === "#email-verified") {
        setVerifySuccess(true);
        setMessage("Email verified.");
      } else if (global.location.hash === "#token-consumed") {
        setVerifySuccess(true);
        setMessage("The verification link is already used.");
      } else if (global.location.hash === "#invalid-token") {
        setVerifySuccess(true);
        setMessage("The verification link is invalid. Please request for a new link.");
      } else if (global.location.hash === "#internal-error") {
        setVerifySuccess(true);
        setMessage("Something went wrong. Please try again.");
      }
    }
  }, []);

  useEffect(() => {
    getNotifications();
    setVerticalMenuBar(false);
    setLocation(getCurrentSite(global.location.host));
    setoriginalLocation(global.location.host);
    isVerticalMenubar && setVerticalMenuBar(false);
    const interval = setInterval(() => {
      getNotifications();
    }, 150000);

    return () => clearInterval(interval);
  }, []);

  const toggleNotifications = () => {
    if (!showNotifications) {
      setDot(false);
    }
    setShowNotifications(!showNotifications);
  };

  const toggleVerticalMenubar = () => {
    setVerticalMenuBar(!isVerticalMenubar);
    setMobileFilter(false);
  };

  const styleName = location ? location + "-wrapper" : "";

  useEffect(() => {
    getUser()
      .then((response) => {
        setMember(response.member);
        const integrationsId = get(publisherAttributes, ["integrations_id"], null);
        if (response.member["verification-status"]) {
          getJwt(integrationsId).then((res) => {
            res.status === 200 && setJwtToken(res.headers.get("x-integration-token"));
          });
        }
      })
      .catch((ex) => console.log(ex.message));
  }, []);

  return (
    <div styleName={`base`} className={styleName}>
      <StaticHeader
        toggleVerticalMenubar={toggleVerticalMenubar}
        isVerticalMenubar={isVerticalMenubar}
        dot={dot}
        toggleNotifications={toggleNotifications}
        showNotifications={showNotifications}
        notifications={notifications}
        location={location}
        originalLocation={originalLocation}
        isDesktop={isDesktop}
      />
      {isVerticalMenubar && (
        <VerticalMenubar
          isDesktop={isDesktop}
          toggleVerticalMenubar={toggleVerticalMenubar}
          hamburgerMenu={hamburgerMenu}
          domainSlug={location}
        />
      )}
      {verifySuccess && showPopUp && member && (
        <PopupOverlay
          lang={publisherAttributes.lang}
          popupMessage={message}
          onClickHandler={changePopupView}
          buttonType="continue"
          buttonContent="Continue"
        />
      )}
      {verifySuccess && !member && showPopUp && (
        <PopupOverlay
          lang={publisherAttributes.lang}
          popupMessage={message}
          buttonType="login"
          buttonContent="Continue"
        />
      )}
    </div>
  );
};

UniformHeader.propTypes = {
  currentPath: string,
  publisherAttributes: object,
  sections: array,
  domainMenuItemsObj: array,
  navigateToPage: func,
  member: object,
  setMember: func,
  setJwtToken: func,
  setBookmark: func,
  setMobileFilter: func,
};

const mapStateToProps = (state) => ({
  domainMenuItemsObj: get(state, ["qt", "data", "navigationMenu", "prothomaloMenuItems"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  member: state.member || null,
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setMember: (member) => dispatch(setMember(member)),
  setJwtToken: (token) => dispatch(setJwtToken(token)),
  setBookmark: (obj) => dispatch(setBookmark(obj)),
  setMobileFilter: (flag) => dispatch(setMobileFilter(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UniformHeader);
